import { render, staticRenderFns } from "./VasionUserGroupSelect.vue?vue&type=template&id=25eae1b2&scoped=true"
import script from "./VasionUserGroupSelect.vue?vue&type=script&lang=js"
export * from "./VasionUserGroupSelect.vue?vue&type=script&lang=js"
import style0 from "./VasionUserGroupSelect.vue?vue&type=style&index=0&id=25eae1b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25eae1b2",
  null
  
)

export default component.exports